import {
  INTERNET_CONNECTED,
  INTERNET_DISCONNECTED,
  API_RATELIMIT_LOCKED,
  API_RATELIMIT_UNLOCKED,
  UPDATE_IDTOKEN_EXPIRED
} from './mutation-types'

// initial state
const state = {
  isOnline: true,
  isApiRateLimitLocked: false
}

// getters
const getters = {
  isOnline: function (state) {
    return state.isOnline
  }
}

// actions
const actions = {
  initializeData: function ({commit, dispatch, state}) {
    return new Promise((resolve, reject) => {
      resolve()
    })
  },
  checkOnlineStatusByApiResponse: function ({commit, state, dispatch}, res) {
    if (res.status === 0) {
      if (state.isOnline) commit(INTERNET_DISCONNECTED)
    } else if (res.status === 429) {
      if (!state.isApiRateLimitLocked) commit(API_RATELIMIT_LOCKED)
    } else if (res.status !== 401 && res.status !== 404) {
      if (!state.isOnline) {
        commit(INTERNET_CONNECTED)
        dispatch('initializeData')
      }
      if (state.isApiRateLimitLocked) commit(API_RATELIMIT_UNLOCKED)
    } else if (res.status === 401) {
      commit(UPDATE_IDTOKEN_EXPIRED, {isExpired: true})
    }
  }
}

// mutations
const mutations = {
  [INTERNET_CONNECTED]: function (state) {
    state.isOnline = true
  },
  [INTERNET_DISCONNECTED]: function (state) {
    state.isOnline = false
  },
  [API_RATELIMIT_LOCKED]: function (state) {
    state.isApiRateLimitLocked = true
  },
  [API_RATELIMIT_UNLOCKED]: function (state) {
    state.isApiRateLimitLocked = false
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/rootModule.js